import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, DialogHandler } from "cakemail-ui-components/lib/react";
import { Translate } from "react-redux-i18n";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import { updateLocalBrand } from "assets/js/scenes/brand/actions";
import BRAND from "assets/js/scenes/brand/const";
import { resizeImgData } from "assets/js/scenes/brand/utils";

export const BrandUpload = (props) => {
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [curentImg, setCurrentImg] = useState(
		props.defaultImg ? props.defaultImg : "/assets/images/settings/Group.png"
	);
	const [extraInfo, setExtraInfo] = useState({});

	useEffect(() => {}, []);

	function resetImg() {
		DialogHandler.hide();
		setSelectedFiles([]);
		setExtraInfo({});
		setCurrentImg(props.defaultImg);
	}

	function getExtraInformation(e, src, file, img) {
		if (
			props.type === "favicon" &&
			(e.currentTarget.naturalWidth !== BRAND.FAV_SIZE_BIG ||
				e.currentTarget.naturalHeight !== BRAND.FAV_SIZE_BIG)
		) {
			DialogHandler.show({
				type: "warning",
				title: <Translate value="app-brand-illustrations-size-error-title" />,
				content: (
					<Translate
						value="app-brand-favicon-size-error-desc"
						width={BRAND.FAV_SIZE_BIG}
						height={BRAND.FAV_SIZE_BIG}
					/>
				),
				primaryBtnText: <Translate value="app-general-got-it" />,
				primaryBtnOnClick: resetImg,
			});
		} else {
			let toDelete = src === props.defaultImg;
			setExtraInfo({
				width: e.currentTarget.naturalWidth || "",
				height: e.currentTarget.naturalHeight || "",
			});

			setCurrentImg(src);
			setSelectedFiles(file);

			if (props.type === "favicon") {
				let splitPath = props.path.split(".")[0];

				let canvas = document.createElement("canvas");
				const bigFav = resizeImgData(canvas, img, BRAND.FAV_SIZE_BIG);
				const medFav = resizeImgData(canvas, img, BRAND.FAV_SIZE_MED);
				const smallFav = resizeImgData(canvas, img, BRAND.FAV_SIZE_SMALL);
				const xSmallFav = resizeImgData(canvas, img, BRAND.FAV_SIZE_XSMALL);

				props.updateLocalBrand(
					props.path,
					bigFav,
					{ value: bigFav, valid: "valid" },
					false
				);
				props.updateLocalBrand(
					splitPath + ".favicon-apple-touch",
					medFav,
					{ value: medFav, valid: "valid" },
					true
				);
				props.updateLocalBrand(
					splitPath + ".favicon-32",
					smallFav,
					{ value: smallFav, valid: "valid" },
					true
				);
				props.updateLocalBrand(
					splitPath + ".favicon-16",
					xSmallFav,
					{ value: xSmallFav, valid: "valid" },
					true
				);
				props.updateLocalBrand(
					splitPath + ".favicon",
					xSmallFav,
					{ value: xSmallFav, valid: "valid" },
					true
				);
			} else if (
				props.type === "logo" &&
				(e.currentTarget.naturalWidth > BRAND.LOGO_MAX_WIDTH ||
					e.currentTarget.naturalHeight > BRAND.LOGO_MAX_HEIGHT)
			) {
				let canvas = document.createElement("canvas");

				const sw = e.currentTarget.naturalWidth;
				const sh = e.currentTarget.naturalHeight;
				const ratio = Math.min(
					BRAND.LOGO_MAX_WIDTH / sw,
					BRAND.LOGO_MAX_HEIGHT / sh
				);

				const newSize = { width: sw * ratio, height: sh * ratio };

				const logo = resizeImgData(canvas, img, newSize.width, newSize.height);
				props.updateLocalBrand(
					props.path,
					logo,
					{ value: logo, valid: "valid" },
					toDelete
				);
			} else {
				props.updateLocalBrand(
					props.path,
					src,
					{ value: src, valid: "valid" },
					toDelete
				);
			}
		}
	}

	function handleDrop(files) {
		if (files.length === 1) {
			const reader = new FileReader();

			reader.onload = function (e) {
				let img = document.createElement("img");
				const src = e.target.result;
				img.src = src;

				img.onload = (e) => {
					getExtraInformation(e, src, files[0], img);
				};
			};

			reader.readAsDataURL(files[0]);
		}
	}

	function onReplace(e) {
		e.stopPropagation();
		//Change selector to find input if we need to change the structure
		e.currentTarget.parentElement.parentElement.children[0].click();
	}

	const maxSize = 1048576; //1mb

	return (
		<div className="brandElement-upload">
			<Dropzone
				onDrop={handleDrop}
				accept="image/*"
				minSize={0}
				maxSize={maxSize}
				multiple={false}
			>
				{({
					getRootProps,
					getInputProps,
					isDragActive,
					isDragReject,
					rejectedFiles,
				}) => {
					let hasImg =
						props.defaultImg != null ||
						(selectedFiles.length === 1 && rejectedFiles.length === 0);
					let message = hasImg ? (
						""
					) : (
						<Translate
							value={
								props.type === "image"
									? "app-brand-logo-upload-text"
									: "app-brand-font-upload-text"
							}
						/>
					);

					if (rejectedFiles.length === 1 && rejectedFiles[0].size > maxSize) {
						message = (
							<Translate
								value="app-settings-drag-error-message-file-too-large"
								className="error"
							/>
						);
					} else if (rejectedFiles.length > 1) {
						message = (
							<Translate
								value="app-settings-drag-error-message-one-file"
								className="error"
							/>
						);
					} else if (isDragReject) {
						message = (
							<Translate
								value="app-settings-rejected-drag-message"
								className="error"
							/>
						);
					}
					return (
						<div {...getRootProps({ className: "dropzone" })}>
							<input {...getInputProps()} multiple={false} />
							<div className="drag-drop-zone">
								<div>
									<img src={curentImg} />
								</div>

								{!hasImg && (
									<div>
										<p>{message}</p>
									</div>
								)}
								{hasImg && (
									<Button
										shapeStyle="stroke"
										colorTheme="grey"
										text={<Translate value="app-general-replace" />}
										onClick={onReplace}
									/>
								)}
							</div>
						</div>
					);
				}}
			</Dropzone>

			{selectedFiles.length === 1 && props.type === "image" && (
				<div className="unpublished">
					<div>
						<p>
							{extraInfo.width}px x {extraInfo.height}px
						</p>
						<p>
							<span>-</span> <span>+</span>
						</p>
					</div>
				</div>
			)}
		</div>
	);
};
//<div><p><Translate value="app-general-retina-ready"/> <InformationTooltip iconName="glyph-info" tooltipText={<Translate value="app-general-retina-ready-explanation"/>}/></p></div>
BrandUpload.propTypes = {
	type: PropTypes.oneOf(["logo", "font", "favicon"]),
	defaultImg: PropTypes.string,
	path: PropTypes.string,
	updateLocalBrand: PropTypes.func,
};

BrandUpload.defaultProps = {
	type: "logo",
	defaultImg: null,
};

export default withRouter(
	connect(
		(state) => {
			return {};
		},
		(dispatch) =>
			bindActionCreators(
				{
					updateLocalBrand,
				},
				dispatch
			)
	)(BrandUpload)
);
